export default __webpack_public_path__ + "static/media/icon_plans.bd5982a0.svg";